@if (showContent) {
  <div class="noDataToCompare">
    <div class=" compareEmptyPageMiddle">
      <div class="comparecontent">
        <h2>"No Products are selected For comparing" <a (click)="goBack()"> Please select some Products </a>
      </h2>
    </div>
  </div>
  <div class="compare-empty">
    <a class="btn btn-Compareempty " (click)="goBack()">
    {{'common.popupproceedToCheckout'|cxTranslate}}</a>
  </div>
</div>
} @else {
  <div class="compare-section">
    <div class="compare-CMSPage-Title">{{'common.text_compare_products'|cxTranslate}}</div>
    <div class="checkBox">
      <input name="showDifference" type="checkbox" (change)="toggleShowDifferences()">
      <label for="showDifference">{{'common.text_compare_show_difference_only'|cxTranslate}}</label>
    </div>
    <div class="compare-CMSPage-SubTitle">{{'common.text_compare_part_number'|cxTranslate}}@if (this.products && (this.products.length < 4)) {
      <a (click)="goBack()"
        class=" btn-yellow  pull-right "
      >{{'common.text_add_button'|cxTranslate}}</a>
    }
  </div>
  <div class="scrollablecompare">
    <div class="compare-section-items ">
      <ul>
        <li class="compare-listHeader differenceArrow">
        </li>
        <li class="compare-listHeader">
          <div class="compare-productTitle compare-lable">
          {{'common.text_product_image'|cxTranslate}}</div>
        </li>
        @for (prod of this.products; track prod) {
          <li class="compare-listHeader img-tab">
            <div class="compare-proeuctThumb">
              <a [routerLink]="{  cxRoute: 'product',params: prod } | cxUrl">
                <img class="prod-image" src="{{baseUrl}}{{prod.images[0].url}}"
                  alt="Brake Chamber (S-Cam)" title="Brake Chamber (S-Cam)">
                </a>
              </div>
              <div class="compare-proeuct-Add2CartButton">
                <app-kb-add-to-cart [showQuantity]="false" [purchasable]="prod.isAddToCart"
                [productCode]="prod?.code" class="kb-product-addToCart"></app-kb-add-to-cart>
                @if (isLoggedIn && prod.isQoute) {
                  <button
                  class='btn btn-primary btn-block check-avl f-20'>{{'common.quote_create'|cxTranslate}}</button>
                }
                @if (prod.isContactUs && isLoggedIn) {
                  <button
                  class='btn btn-primary btn-block check-avl f-20'>{{'common.pdp_page_contact_us'|cxTranslate}}</button>
                }
                @if (prod.isEnqury && isLoggedIn) {
                  <a
                                [href]="'mailto:' + prod?.contactEmail + '?subject=' + prod?.code"
                                class='btn btn-block btn-primary btn-block check-avln f-20'>
                    {{'common.pdp_page_contact_enquiry'|cxTranslate}}
                  <img src="/icons/mail-white.svg" alt="Enquiry" class="mail-icon" width="20" /></a>
                }
                <div>
                  <input type="hidden" name="CSRFToken" value="b739f1dd-850b-4132-8be5-07a38131e2df">
                </div>
              </div>
            </li>
          }
        </ul>
        <ul>
          <li class="removeBlock differenceArrow"></li>
          <li class="removeBlock">
          </li>
          @for (prod of this.products; track prod) {
            <li class="removeBlock">
              <div class="compare-remove-Block">
                <a (click)="removeProd(prod.code)" class="btn">
                  <img src="/icons/close-light-grey.svg" class="close-icon" alt="close-icon"></a>
                  <span class="removered">{{'common.text_productCompare_page_remove'|cxTranslate}}</span>
                </div>
              </li>
            }
          </ul>
          @if (code) {
            <ul>
              <li class="compare-odd differenceArrow"></li>
              <li class="compare-odd">
                <div class="compare-lable ">
                  <strong>{{'common.text_part_number'|cxTranslate}}</strong>
                </div>
              </li>
              @for (prod of this.products; track prod) {
                <li class="compare-odd prod-results-green">
                  <div class="compare-lable">
                    <a [routerLink]="{  cxRoute: 'product',params: prod } | cxUrl">
                      {{prod.code}}
                    </a>
                  </div>
                </li>
              }
            </ul>
          }
          @if (name) {
            <ul>
              <li class="compare-odd differenceArrow"></li>
              <li class="compare-odd">
                <div class="compare-lable"><strong>{{'common.text_account_savedCart_description'
                |cxTranslate}}</strong></div>
              </li>
              @for (prod of this.products; track prod) {
                <li class="compare-odd">
                  <div class="compare-lable">{{prod.name}}</div>
                </li>
              }
            </ul>
          }
          @if (typenumber) {
            <ul>
              <li class="compare-odd differenceArrow"></li>
              <li class="compare-odd">
                <div class="compare-lable"><strong>{{'common.product_product_typenumber'
                |cxTranslate}}</strong></div>
              </li>
              @for (prod of this.products; track prod) {
                <li class="compare-odd">
                  <div class="compare-lable">{{prod.typenumber}}</div>
                </li>
              }
            </ul>
          }
          @if (salesStatusText && shouldShowUl('salesStatusText')) {
            <ul>
              <li class="compare-odd differenceArrow">
                @if (anyDifferences('salesStatusText')) {
                  <span>
                    <img src="/icons/link-right-red.svg" class="icon-right" alt="salesStatusText"></span>
                  }
                </li>
                <li class="compare-odd">
                  <div class="compare-lable"><strong>{{'common.text_sales_status'|cxTranslate}}</strong></div>
                </li>
                @for (prod of this.products; track prod) {
                  <li class="compare-odd">
                    @if (!showDifferencesOnly || hasDifferences(prod,products[0])) {
                      <div class="compare-lable">
                      {{prod.salesStatusText}}</div>
                    }
                    @if (showDifferencesOnly && !hasDifferences(prod, products[0])) {
                      <div class="compare-lable">{{
                      prod.salesStatusText }}</div>
                    }
                  </li>
                }
              </ul>
            }
            @if (shouldShowUl('marketType')) {
              <ul>
                <li class="compare-odd differenceArrow">
                  @if (anyDifferences('marketType')) {
                    <span><img src="/icons/link-right-red.svg" alt="marketType"
                    class="icon-right"></span>
                  }
                </li>
                <li class="compare-odd">
                  <div class="compare-lable">
                    <strong>{{'common.text_market'|cxTranslate}}</strong>
                  </div>
                </li>
                @for (prod of this.products; track prod) {
                  <li class="compare-odd">
                    @if (!showDifferencesOnly || hasDifferences(prod,products[0])) {
                      <div class="compare-lable">
                        <a [routerLink]="{  cxRoute: 'product',params: prod } | cxUrl">
                          {{prod.marketType}}
                        </a>
                      </div>
                    }
                    @if (showDifferencesOnly &&!hasDifferences(prod,products[0])) {
                      <div class="compare-lable">
                        <a [routerLink]="{  cxRoute: 'product',params: prod } | cxUrl">
                          {{prod.marketType}}
                        </a>
                      </div>
                    }
                  </li>
                }
              </ul>
            }
            @if (isLoggedIn && shouldShowUl('')) {
              <ul>
                <li class="compare-odd differenceArrow">
                  @if (anyDifferences('listPrice')) {
                    <span><img src="/icons/link-right-red.svg" alt="listPrice"
                    class="icon-right"></span>
                  }
                </li>
                <li class="compare-odd">
                  <div class="compare-lable"><strong>{{'common.basket_page_customerprice'|cxTranslate}}</strong>
                </div>
              </li>
              @for (prod of this.products; track prod) {
                <li class="compare-odd">
                  @if (prod?.listPrice ) {
                    <div class="compare-lable ">
                      <a>{{prod?.listPrice?.formattedValue}}{{prod?.listPrice?.currencyIso}}</a>
                    </div>
                  } @else {
                    @if (prod?.priceOnRequestText) {
                      <div class="compare-lable">
                        <a>{{prod?.priceOnRequestText|cxTranslate}}</a>
                      </div>
                    }
                  }
                </li>
              }
            </ul>
          }
          @if (isLoggedIn && shouldShowUl('corePrice')) {
            <ul>
              <li class="compare-odd differenceArrow">
                @if (anyDifferences('corePrice')) {
                  <span><img src="/icons/link-right-red.svg" alt="corePrice"
                  class="icon-right"></span>
                }
              </li>
              <li class="compare-odd">
                <div class="compare-lable"><strong>{{'common.basket_page_coreCharges'|cxTranslate}}</strong>
              </div>
            </li>
            @for (prod of this.products; track prod) {
              <li class="compare-odd">
                @if (prod?.corePrice ) {
                  <div class="compare-lable ">
                    <a>{{prod?.corePrice?.formattedValue}}{{prod?.corePrice?.currencyIso}}</a>
                  </div>
                } @else {
                  @if (prod?.priceOnRequestText) {
                    <div class="compare-lable ">
                      <a>{{prod?.priceOnRequestText|cxTranslate}}</a>
                    </div>
                  }
                }
              </li>
            }
          </ul>
        }
        <!-- code for untyped features Map -->
        @for (untypedFeatures of this.unTyped; track untypedFeatures) {
          @if (shouldShowUntypedUl(untypedFeatures)) {
            <ul>
              <li class="compare-odd differenceArrow">
                @if (anyUntypedDifferences(untypedFeatures)) {
                  <span><img
                  src="/icons/link-right-red.svg" class="icon-right"></span>
                }
              </li>
              <li class="compare-odd">
                <div class="compare-lable"><strong>{{untypedFeatures.key}}</strong></div>
              </li>
              @for (value of untypedFeatures.value ; track value) {
                <li class="compare-odd prod-results-green">
                  @if (!showDifferencesOnly || anyUntypedDifferences(untypedFeatures)) {
                    <div class="compare-lable"
                      ><a>{{ value
                    }}</a></div>
                  }
                </li>
              }
            </ul>
          }
        }

        <!-- hight width length and other features can be added in the same way as untyped features by adding them to the products as untyped features in the backend and then they will be automatically rendered in the frontend without any code change by using the untyped features map which is already implemented. -->

         @if (shouldShowUl('grossWeight')) {
            <ul>
              <li class="compare-odd differenceArrow">
                @if (anyDifferences('grossWeight')) {
                  <span><img src="/icons/link-right-red.svg" alt="grossWeight"
                  class="icon-right"></span>
                }
              </li>
              <li class="compare-odd">
                <div class="compare-lable"><strong>{{'common.text_generalInfo_grossWeight'|cxTranslate}}</strong>
              </div>
            </li>
            @for (prod of this.products; track prod) {
              <li class="compare-odd">
                @if (prod?.grossWeight ) {
                  <div class="compare-lable ">
                    <a>{{prod?.grossWeight}} Kg {{prod?.convertedGrossWeight}}</a>
                  </div>
                } @else {
                    <div class="compare-lable ">
                      <a></a>
                    </div>
                }
              </li>
            }
          </ul>
        }

        @if (shouldShowUl('netWeight')) {
            <ul>
              <li class="compare-odd differenceArrow">
                @if (anyDifferences('netWeight')) {
                  <span><img src="/icons/link-right-red.svg" alt="netWeight"
                  class="icon-right"></span>
                }
              </li>
              <li class="compare-odd">
                <div class="compare-lable"><strong>{{'common.text_generalInfo_netWeight'|cxTranslate}}</strong>
              </div>
            </li>
            @for (prod of this.products; track prod) {
              <li class="compare-odd">
                @if (prod?.netWeight ) {
                  <div class="compare-lable ">
                    <a>{{prod?.netWeight}} Kg {{prod?.convertedNetWeight}}</a>
                  </div>
                } @else {
                    <div class="compare-lable ">
                      <a></a>
                    </div>
                }
              </li>
            }
          </ul>
        }
        @if (shouldShowUl('dimensionLength')) {
            <ul>
              <li class="compare-odd differenceArrow">
                @if (anyDifferences('dimensionLength')) {
                  <span><img src="/icons/link-right-red.svg" alt="dimensionLength"
                  class="icon-right"></span>
                }
              </li>
              <li class="compare-odd">
                <div class="compare-lable"><strong>{{'common.text_dimension_length'|cxTranslate}}</strong>
              </div>
            </li>
            @for (prod of this.products; track prod) {
              <li class="compare-odd">
                @if (prod?.dimensionLength ) {
                  <div class="compare-lable ">
                    <a>{{prod?.dimensionLength}} mm {{prod?.convertedLength}}</a>
                  </div>
                } @else {
                    <div class="compare-lable ">
                      <a></a>
                    </div>
                }
              </li>
            }
          </ul>
        }
        @if (shouldShowUl('dimensionWidth')) {
            <ul>
              <li class="compare-odd differenceArrow">
                @if (anyDifferences('dimensionWidth')) {
                  <span><img src="/icons/link-right-red.svg" alt="dimensionWidth"
                  class="icon-right"></span>
                }
              </li>
              <li class="compare-odd">
                <div class="compare-lable"><strong>{{'common.text_dimension_width'|cxTranslate}}</strong>
              </div>
            </li>
            @for (prod of this.products; track prod) {
              <li class="compare-odd">
                @if (prod?.dimensionWidth ) {
                  <div class="compare-lable ">
                    <a>{{prod?.dimensionWidth}} mm {{prod?.convertedWidth}}</a>
                  </div>
                } @else {
                    <div class="compare-lable ">
                      <a></a>
                    </div>
                }
              </li>
            }
          </ul>
        }
        @if (shouldShowUl('dimensionHeight')) {
            <ul>
              <li class="compare-odd differenceArrow">
                @if (anyDifferences('dimensionHeight')) {
                  <span><img src="/icons/link-right-red.svg" alt="dimensionHeight"
                  class="icon-right"></span>
                }
              </li>
              <li class="compare-odd">
                <div class="compare-lable"><strong>{{'common.text_dimension_height'|cxTranslate}}</strong>
              </div>
            </li>
            @for (prod of this.products; track prod) {
              <li class="compare-odd">
                @if (prod?.dimensionHeight ) {
                  <div class="compare-lable ">
                    <a>{{prod?.dimensionHeight}} mm {{prod?.convertedHeight}}</a>
                  </div>
                } @else {
                    <div class="compare-lable ">
                      <a></a>
                    </div>
                }
              </li>
            }
          </ul>
        }


        <!-- end of untyped features code -->
      </div>
    </div>
    <div class="compare-backBlock">
      <a class="compare-back2page" (click)="goBack()"><img src="/icons/link_left-blue.svg" alt="back"
      class="icon-right">{{'common.text_back_to_result_button'|cxTranslate}}</a>
    </div>
  </div>
}

